import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4282fe27"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "ss-titulo-card" }, "Minhas Tarefas", -1))
const _hoisted_3 = { style: {"overflow-y":"auto","height":"calc(100% - 60px)","max-height":"calc(100% - 60px)"} }
const _hoisted_4 = { class: "ant-row" }
const _hoisted_5 = {
  class: "ant-col",
  style: {"flex":"0 0 30px","padding-top":"3px","text-align":"center"}
}
const _hoisted_6 = {
  class: "ant-col",
  style: {"flex":"1 1 auto","padding-top":"4px"}
}
const _hoisted_7 = {
  class: "ant-col",
  style: {"flex":"0 0 40px","padding-top":"6px"}
}
const _hoisted_8 = { class: "ant-row" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { style: {"margin-top":"-20px","margin-left":"-15px","margin-right":"-15px"} }
const _hoisted_12 = {
  key: 0,
  class: "ss-card-tarefa"
}
const _hoisted_13 = { class: "ant-row" }
const _hoisted_14 = {
  class: "ant-col",
  style: {"flex":"0 0 30px","padding-top":"3px","text-align":"center"}
}
const _hoisted_15 = {
  class: "ant-col",
  style: {"flex":"1 1 auto","padding-top":"4px"}
}
const _hoisted_16 = {
  class: "ant-col",
  style: {"flex":"0 0 40px","padding-top":"6px"}
}
const _hoisted_17 = { class: "ant-row" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "ant-row ss-card-tarefa" }
const _hoisted_21 = {
  class: "ant-col",
  style: {"flex":"1 1 auto"}
}
const _hoisted_22 = { class: "ant-input-affix-wrapper ss-input-novo" }
const _hoisted_23 = { class: "ant-input-suffix" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_icone = _resolveComponent("icone")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_minhas_tarefas_editar_modal = _resolveComponent("minhas-tarefas-editar-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_ctx.state.tarefas.length > 0)
          ? (_openBlock(), _createBlock(_component_draggable, {
              key: 0,
              modelValue: _ctx.state.tarefas,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.tarefas) = $event)),
              "item-key": "codigo",
              handle: ".ss-mover",
              onSort: _ctx.atualizarOrdemTarefas
            }, {
              item: _withCtx(({ element, index }) => [
                (element.status === _ctx.EStatusTarefaPessoal.Aberta)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: element.codigo,
                      class: "ss-card-tarefa ss-mover"
                    }, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_component_a_checkbox, {
                            checked: false,
                            onChange: ($event: any) => (_ctx.concluirTarefa(index))
                          }, null, 8, ["onChange"])
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("span", null, _toDisplayString(element.descricao), 1)
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("a", {
                              onClick: ($event: any) => (_ctx.abrirEdicaoTarefa(index))
                            }, [
                              _createVNode(_component_icone, {
                                class: "ss-icone",
                                nome: "editar"
                              })
                            ], 8, _hoisted_9),
                            _createElementVNode("a", {
                              onClick: ($event: any) => (_ctx.excluirTarefa(index))
                            }, [
                              _createVNode(_component_icone, {
                                class: "ss-icone",
                                nome: "excluir",
                                style: {"margin-left":"2px"}
                              })
                            ], 8, _hoisted_10)
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue", "onSort"]))
          : _createCommentVNode("", true),
        (_ctx.state.qtdConcluidas > 0)
          ? (_openBlock(), _createBlock(_component_a_collapse, {
              key: 1,
              activeKey: _ctx.state.exibirConcluidas,
              "onUpdate:activeKey": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.exibirConcluidas) = $event)),
              ghost: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_collapse_panel, {
                  key: "1",
                  header: 'Concluídas('+ _ctx.state.qtdConcluidas + ')'
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.tarefas, (tarefa, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                          (tarefa.status ===_ctx.EStatusTarefaPessoal.Concluida)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                  _createElementVNode("div", _hoisted_14, [
                                    _createVNode(_component_a_checkbox, {
                                      checked: true,
                                      onChange: ($event: any) => (_ctx.concluirTarefa(index))
                                    }, null, 8, ["onChange"])
                                  ]),
                                  _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("span", null, _toDisplayString(tarefa.descricao), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_16, [
                                    _createElementVNode("div", _hoisted_17, [
                                      _createElementVNode("a", {
                                        onClick: ($event: any) => (_ctx.abrirEdicaoTarefa(index))
                                      }, [
                                        _createVNode(_component_icone, {
                                          class: "ss-icone",
                                          nome: "editar"
                                        })
                                      ], 8, _hoisted_18),
                                      _createElementVNode("a", {
                                        onClick: ($event: any) => (_ctx.excluirTarefa(index))
                                      }, [
                                        _createVNode(_component_icone, {
                                          class: "ss-icone",
                                          nome: "excluir",
                                          style: {"margin-left":"2px"}
                                        })
                                      ], 8, _hoisted_19)
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }, 8, ["header"])
              ]),
              _: 1
            }, 8, ["activeKey"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("span", _hoisted_22, [
            _withDirectives(_createElementVNode("input", {
              placeholder: "Nova Tarefa",
              type: "text",
              class: "ant-input hidden",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.novaTarefa) = $event))
            }, null, 512), [
              [_vModelText, _ctx.state.novaTarefa]
            ]),
            _createElementVNode("span", _hoisted_23, [
              _createVNode(_component_a_spin, {
                spinning: _ctx.state.incluindoTarefa
              }, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.adicionarTarefa && _ctx.adicionarTarefa(...args)))
                  }, [
                    _createVNode(_component_icone, {
                      nome: "novo",
                      class: "ss-icone"
                    })
                  ])
                ]),
                _: 1
              }, 8, ["spinning"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_minhas_tarefas_editar_modal, {
      visivel: _ctx.state.exibirEdicao,
      "onUpdate:visivel": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.exibirEdicao) = $event)),
      descricao: _ctx.state.descricaoSelecionada,
      onConfirmacao: _ctx.editarTarefa
    }, null, 8, ["visivel", "descricao", "onConfirmacao"])
  ], 64))
}